import PopupModal from 'app/shared/modules/popups/PopupModal';
import { CostAndFeesContent } from './CostsAndFeesContent';
import { CostsAndFeesContextProvider } from './context/CostsAndFeesProvider';
import { popupModalStyles } from './CostsAndFeesModal.styles';

interface CostAndFeesModalProps {
  isWebview: boolean;
  onHidePopup: () => void;
}

const CostAndFeesModal: React.FC<CostAndFeesModalProps> = ({
  isWebview = false,
  onHidePopup,
}: CostAndFeesModalProps) => {
  return (
    <PopupModal
      className={popupModalStyles}
      aria-labelledby="dialog-title"
      data-testid="cost-and-fees-modal"
      onHidePopup={onHidePopup}
      paddingTop={isWebview ? '1x' : '2x'}
      paddingBottom="1x"
      scrollablePaddingInline="2x"
      useCloseButton={!isWebview}
      isWebview={isWebview}
      disableMobileScrollLock={true}
    >
      <CostsAndFeesContextProvider>
        <CostAndFeesContent isWebView={isWebview} />
      </CostsAndFeesContextProvider>
    </PopupModal>
  );
};

export default CostAndFeesModal;
